import { Col, Container, Row } from 'reactstrap'
import LoginForm from '../Common/LoginForm'

const LoginWithBackGroundImageContainer = () => {
  return (
    <Container fluid>
      <Row>
        <Col xl="7" className="b-center bg-size p-0 loginImageBg" />
        <Col xl="5" className="p-0">
          <LoginForm />
        </Col>
      </Row>
    </Container>
  )
}

export default LoginWithBackGroundImageContainer